import { useSelector } from "react-redux";
import { selectCurrentUser } from '../../Store/api/auth/authSelectors';
import {
  getCurrentUrl,
  getLoggedOutEndpoint,
  getSamlLoginEndPoint,
  getSamlLogoutEndPoint,
  getProxyLogoutEndPoint,
  endProxyAndRedirect
} from "../../ServiceUtils/auth";
import { USER_APPLICATION_SESSION_KEY } from "../../MPP-Common-SPA/utils/globalUtility";
import { useAnalyticsStep } from "../../MPP-Common-SPA/utils/useAnalyticsStep";
import { trackEvent } from "../../MPP-Common-SPA/utils/analytics";
import { SIGN_OUT_EVENT, SIGN_OUT_PARAM_KEY } from "../../MPP-Common-SPA/utils/analytics-constants";

export const useLogin = () => {
  
  const user = useSelector(selectCurrentUser);
  const currentStep = useAnalyticsStep();

  const handleLogin = (callbackUrl) => {
    const targetUrl = callbackUrl || getCurrentUrl();
    window.location = getSamlLoginEndPoint(targetUrl);
  };

  const handleLogout = async (redirectUrl) => {
    // Before clearing the session storage, get user's last step and send GA event.
    trackEvent(
      SIGN_OUT_EVENT,
      { [SIGN_OUT_PARAM_KEY]: currentStep }
    );
    const storedUserApplication = JSON.parse(sessionStorage.getItem(USER_APPLICATION_SESSION_KEY)) ?? {};

    localStorage.clear();
    sessionStorage.removeItem(USER_APPLICATION_SESSION_KEY);
  
    if (user.isProxyUser) {
      // If redirectUrl is provided, the proxy user is returning from an edit flow
      // and should land on the application summary page.
      // Otherwise (e.g. "Go to workspace" button), redirect to /workspace.Expand commentComment on line R40Resolved
      const applicationId = redirectUrl ? (storedUserApplication.applicationId || null) : null;
      await endProxyAndRedirect(applicationId, user.programId);
    } else {
      window.location.href = redirectUrl
        ? getSamlLogoutEndPoint(redirectUrl)
        : getSamlLogoutEndPoint(getLoggedOutEndpoint());
    }
  };

  return {
    handleLogout,
    handleLogin
  };
};
